(function($) {
  "use strict";


  if($("#shopify-section-template--14654952243266__text_with_icons_iGYrrG").length) {
    $("#shopify-section-template--14654952243266__text_with_icons_iGYrrG .textwith__icon--content .textwith__icon--content-block").each(function(){
      const linkPage = $(this).find(".rte a").attr("href"),
            ico = $(this).find(".box-ratio img"),
            newLink = $('<a></a>').attr('href', linkPage);
       ico.wrap(newLink);
    });
  }
  
   const wW = $(window).width();

  if(wW < 980){
    const newMenuWrapper = $("<div class='slide-menu'><div class='slide-menu-close'>&times;</div><div class='slide-menu-title'></div><div class='slide-menu-content'></div></div>");
    $("body").append(newMenuWrapper);
  }

  $(document).on("click", ".slide-menu-close", function(){
    const slideParent = $(this).parents(".slide-menu");
    if(slideParent.hasClass("open"))
      slideParent.removeClass("open");
  });
  
  
  $(document).on("click", "#c-accordion--mobile- .js-accordion-header .dropdown-arrow", function(e){
    e.preventDefault();
    e.stopPropagation();
    const menuParent     = $(this).parents(".js-accordion-header"),
          menuTitle      = $.trim(menuParent.find(".c-accordion__link").text()),
          menuContentAcc = $(this).attr("aria-controls"),
          menuContent    = $(`#${menuContentAcc}`).html();

    $(".slide-menu-title").html(menuTitle);
    $(".slide-menu-content").html(menuContent);
    if(!$(".slide-menu").hasClass("open"))
      $(".slide-menu").addClass("open");
  });

  $(document).on("click", ".slide-menu-content .dropdown-arrow", function(){
    const menuContentAccordeon = $(this).attr("aria-controls");

    if(!$(this).hasClass("active")){
      $(this).addClass("active");
      $(`.slide-menu-content #${menuContentAccordeon}`).addClass("active").addClass("is-active");
    } else{
      $(this).removeClass("active");
      $(`.slide-menu-content #${menuContentAccordeon}`).removeClass("active").removeClass("is-active");
    }
  });
  

    let navDistance;
  $(window).scroll(function() {
    
    const scrollTop = $(this).scrollTop();

    console.log(scrollTop, navDistance);

    
    if(scrollTop > navDistance)
        $(".header-section > #nav").css("position", "fixed");
    else 
        $(".header-section > #nav").removeAttr("style");
  });

  const swiper = new Swiper('.swiper', {
    loop: true,
    autoplay: {
       delay: 0,
     }, 
    slidesPerView	: 1,
    speed: 6000, 
    disableOnInteraction: false,
    waitForTransition: false,
    roundLengths	: true,
    breakpoints: {
      767: {
        slidesPerView	: 3,
      }
    }
  });


  $("ul#cart > li.search-icon .button-as-link").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    
    if(!$(".large-search.search-mobile-only").hasClass("show")){
      $(".large-search.search-mobile-only").addClass("show");
      $(".large-search.search-mobile-only").attr("style", "display: block !important");
    } else {
      $(".large-search.search-mobile-only").removeClass("show");
      $(".large-search.search-mobile-only").removeAttr("style");
    }
  });
  
  let menuSize       = 0,
      numberOfCicles = 0,
      numberOfTimes  = 0;
  
  setTimeout(function(){

    // if($(".product__variants-swatches").length > 0) {
    //   console.log("he");
    //   $(".product__variants-swatches .js-variant-selector").each(function(){
    //     $(this).find(".swatch-element").each(function(){
    //       $(this).find("input").prop("checked", false);
    //     });
    //   });
    // }
    navDistance = $(".header-section > #nav").offset().top;
    const windowWidth = $(window).width();
    $("#nav .navigation__menuitem").each(function(){
      menuSize += $(this).width();
      if(menuSize < windowWidth)
        $(this).addClass("menu-visible");
    }); 
    menuSize += 100;
    $("ul#nav").css(`width`, `${menuSize}px`).attr("data-width", menuSize);

    $("nav#nav .navigation__maincontainer").attr("data-translate", "0");

    addArrows();

    if($(".template-collection").length > 0){
      let oldImage, colorParent, oldSrcSet;
      $(".template-collection .color.options li a span").on("mouseenter", function(){
        const hoverImg = $(this).css("background-image").replace('url("', ""). replace('&width=100")', '');
        colorParent = $(this).parents(".product-index"),
        
        oldImage  = colorParent.find(".prod-container .box-ratio img").attr("src");
        oldSrcSet = colorParent.find(".prod-container .box-ratio img").attr("srcset");
        
        colorParent.find(".prod-container .box-ratio img").attr("src", hoverImg).attr("srcset", hoverImg);
      }).on("mouseleave", function(){
        colorParent.find(".prod-container .box-ratio img").attr("src", oldImage).attr("srcset", oldSrcSet);
      });

      $(".template-collection .color.options li a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
      });
    }
      
  }, 500);
  
  $(window).resize(function() {
    const windowWidth = $(window).width();
    if(windowWidth > 980){
      addArrows();
      $("nav#nav .navigation__maincontainer").css("transform", `translateX(0px)`);
      $("nav#nav .arrow-container.left").addClass("hidden");
      $("nav#nav .arrow-container.right").removeClass("hidden");
      numberOfCicles = 0,
      numberOfTimes  = 0;
    }
      
  });

  $(document).on("click", ".arrow-btn", function(){
    const menuWidth    = parseInt($("ul#nav").attr('data-width')),
          windowWidth  = $(window).width(),
          parentArrow  = $(this).parents('.arrow-container'),
          moveRight    = (parentArrow.hasClass("right")) ? true : false,
          navParent    = $("nav#nav"),
          navContainer = navParent.find(".navigation__maincontainer"),
          totalItems   = navContainer.find(".navigation__menuitem").length;
      
    
    let menuTranslate = parseInt(navContainer.attr("data-translate")),
        newMove       = 0,
        newItems      = 0;

    if(moveRight){
      $("#nav .navigation__menuitem").each(function(){
        if($(this).hasClass("menu-visible") && !$(this).hasClass("past"))
          $(this).addClass("past");
        else if(!$(this).hasClass("menu-visible") && !$(this).hasClass("past")){
          if((newMove + $(this).width()) < windowWidth){
            newMove += $(this).width();  
            $(this).addClass("menu-visible");
          }
            
        }
        
      });
  
      newMove = menuTranslate + newMove + 70;
        
      navParent.find(".arrow-container.left").removeClass("hidden");
      
      if($("#nav .navigation__menuitem").last().hasClass("menu-visible"))
        navParent.find(".arrow-container.right").addClass("hidden");
    } else {
      $($("#nav .navigation__menuitem").get().reverse()).each(function(){
        if($(this).hasClass("menu-visible") && !$(this).hasClass("past")){
          if((newMove + $(this).width()) < windowWidth){
            newMove += $(this).width();  
            $(this).removeClass("menu-visible");
          }
        }
        else if($(this).hasClass("menu-visible") && $(this).hasClass("past")){
          if((newItems + $(this).width()) < windowWidth){
            newItems += $(this).width();
            
            $(this).removeClass("past");
            
          }
            
        }
        
      });

      newMove = menuTranslate - (newMove +20);

      navParent.find(".arrow-container.right").removeClass("hidden");
      if(!$("#nav .navigation__menuitem").first().hasClass("past")){
        navParent.find(".arrow-container.left").addClass("hidden");
        newMove = 0;
      }
    }

    if(newMove < 0)
      newMove = newMove * -1;

    navContainer.attr("data-translate", newMove);
    navContainer.css("transform", `translateX(-${newMove}px)`);
  
    
  });

  const addArrows = () => {
    const windowWidth = $(window).width();

    console.log("windowWidth",windowWidth);
    console.log("menuSize",menuSize);

    if(windowWidth < menuSize){
      
      const button = `<div class='arrow-btn'><svg class="fash--apollo-down-carrot navigation__menulink--icon vib-center" height="6px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 13.3" xml:space="preserve">
                        <g class="hover-fill" fill="var(--nav-color)">
                          <polygon points="17.7,0 10,8.3 2.3,0 0,2.5 10,13.3 20,2.5 "></polygon>
                        </g>
                        <style>.navigation__menulink .fash--apollo-down-carrot:hover .hover-fill { fill: var(--nav-hover-link-color);}</style>
                      </svg></div>`;

      
      let buttonContainerLeft  = $(`<div class='arrow-container left hidden'>${button}</div>`),
          buttonContainerRight = $(`<div class='arrow-container right'>${button}</div>`);
      

      if($(".arrow-container").length === 0)
        $("nav#nav").append(buttonContainerLeft).append(buttonContainerRight);


      var cont = $('.navigation__maincontainer').width();
      $('.megamenu').css('max-width', cont);
    }
  }


  
})(jQuery);